import React, { useEffect, useState } from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { flexcol } from '../../global';
import { EventType } from '../../services/Types';
import { useEvent } from '../../hooks/useEvent';
import DropDownSelectorAvailableTimes from '../../components/DropDownSelector/DropDownSelectorAvailableTimes';

interface SchedulerOpenProps {
  selectedDate: Date | null;
  eventType: EventType;
  startTime: number;
  endTime: number;
  setStartTime: (val: number) => void;
  setEndTime: (val: number) => void;
}

const SchedulerOpen: React.FC<SchedulerOpenProps> = ({
  selectedDate,
  eventType,
  startTime,
  endTime,
  setStartTime,
  setEndTime,
}) => {
  const { getDurationOptions } = useEvent();
  const [duration, setDuration] = useState<number>(30);
  const durationOptions = getDurationOptions(eventType);

  // When startTime or duration changes, update endTime
  useEffect(() => {
    if (startTime && duration) {
      const newEnd = startTime + duration;
      setEndTime(newEnd);
    }
  }, [startTime, duration]);

  return (
    <Box style={flexcol} sx={{ marginTop: 2, marginRight: -3, marginLeft: -3 }}>
      <DropDownSelectorAvailableTimes
        selectedDate={selectedDate}
        startTime={startTime}
        duration={duration}
        category="live"
        audience={500}
        onTimeSelect={setStartTime}
      />

      <FormControl fullWidth sx={{ mt: 2 }}>
        <InputLabel>Duration (minutes)</InputLabel>
        <Select
          value={duration}
          label="Duration (minutes)"
          onChange={(e) => setDuration(Number(e.target.value))}
        >
          {durationOptions.map((option) => (
            <MenuItem key={option} value={option}>
              {option} min
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default SchedulerOpen;